const BigIntMath = {
    min: (...values) => values.reduce((prev, curr) => (prev === undefined ? curr : prev < curr ? prev : curr), undefined) ?? 0n,
    max: (...values) => values.reduce((prev, curr) => (prev === undefined ? curr : prev > curr ? prev : curr), undefined) ?? 0n,
};
export default BigIntMath;
//# sourceMappingURL=BigIntMath.js.map